module.exports = __webpack_public_path__ + "static/media/contractor.eae10797.svg";